import apiService from '../apiService';
import { handleHttpError } from '../errorHandler';

// 取得詳細狀態列表
export const getDetailStatus = async (params = {}) => {
    try {
        const response = await apiService.GET('api/admin/detail-status', params);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * 批次取得多個欄位的詳細狀態
 * @param {Object} payload
 * @param {number[]} payload.field_ids - 欄位 ID 陣列
 * @returns {Promise<Object>} 回傳格式：{ status: 1, data: { [field_id]: [statuses...] } }
 */
export const getDetailStatusBatch = async (payload) => {
    try {
        const url = '/api/admin/finance/detail-status/batch';
        const response = await apiService.POST(url, payload);
        return response;
    } catch (error) {
        throw handleHttpError(error, url, 'POST');
    }
};

// 新增詳細狀態
export const createDetailStatus = async (data) => {
    try {
        const response = await apiService.POST('api/admin/detail-status', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 更新詳細狀態
export const updateDetailStatus = async (id, data) => {
    try {
        const response = await apiService.PUT(`api/admin/detail-status/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 刪除詳細狀態
export const deleteDetailStatus = async (id) => {
    try {
        const response = await apiService.DELETE(`api/admin/detail-status/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}; 
